
  <h2 mat-dialog-title>
   <div class="task-list-header">
  <span class="task-title" style="font-weight: bold;">Task List - {{ myTaskText }}</span>
   <button mat-icon-button color="primary" class="openNew"  matTooltip="Open task list in new window" (click)="OpenTaskListinNewTab()">
    <mat-icon>open_in_new</mat-icon> 
    </button>
  <br />
  <span class="task-subtitle">
    Manage and track all tasks for {{ myTaskText }}. {{ completedTasks }} of {{ totalTasks }} tasks completed
  </span>  
</div>


    <button mat-icon-button (click)="closeTask()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <div class="task-progress-summary">
  <div class="summary-header">
    <span class="title">Task Progress Summary</span>    
  </div>

  <div class="summary-status">
    <a> {{ completedTasks }} Completed</a> •
    <a> {{ openTasks }} Open</a> •
    <a> {{ inProgressTasks }} In Progress</a> •
    <a> {{ blockedTasks }} Stuck</a> •
    <a> {{ declinedTasks }} Declined</a>
  </div>
</div>
<br>

  
   <mat-dialog-content>
    
    <div class="">      

      <button mat-icon-button *ngIf="showMoveToOption" (click)="deleteMultipleTask()">
        <mat-icon>delete</mat-icon>
      </button>

    <div class="tableHolder">
    <mat-card class="task_holder--group--items--row cellHeader">

      <div class="task_header_holder cvcxxcv">
        <ng-container>
          <div class="task-cell cellName">
            <div class="Headeroutside">
              <!-- <mat-checkbox class="taskcheck" color="primary" [disabled]="ShowNoRecordFound"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()">
               </mat-checkbox>    -->
            </div>
            Title
          </div>      
          <div class="task-cell cellDueDate">Required</div>   
          <div class="task-cell cellDueDate">Assignee</div>
          <div class="task-cell cellDueDate">Due date</div>
          <div class="task-cell cellStatus">Status</div>
          <div class="task-cell cellPriority">Priority</div>
          <div class="task-cell cellAction">Action</div>
        </ng-container>     
      </div>

    </mat-card>

    <div class="task_holder" *ngFor="let column of columns" style="width:100%">
      <div class="task_holder--group" cdkDropList [cdkDropListData]="column.groups"
        (cdkDropListDropped)="dropGroup($event)">
        <mat-card class="task_holder--group--items" *ngFor="let group of column.groups" cdkDropListGroup cdkDrag
          [cdkDragDisabled]="group.dragDisabled" [cdkDragData]="group">
          <h2 *ngIf="taskListID>0 && group.id!=0">

            <ng-container *ngIf="group.id==0">
              {{group.title}}
            </ng-container>

            <input *ngIf="group.id>0" type="text" maxlength="50" (change)="onChangeGroupName($event,group)"
              value="{{group.title}}">
  
            <span class="delete">          

              <ng-container *ngIf="group.id>0">
                <button mat-icon-button class="trash" (click)="removeGroup(group)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </ng-container>
            

            </span>

          </h2>

          <form [formGroup]="statusGroup">
            <mat-card style="width:100%" class="" cdkDropList id="{{group.id}}"
              [cdkDropListData]="group.items" (cdkDropListDropped)="dropItem($event)"
              [cdkDropListConnectedTo]="getConnectedList()">

              <div  class="task_holder--group--items--row" *ngFor="let item of group.items; let i = index" cdkDrag
                [cdkDragData]="item" [cdkDragDisabled]="taskListID==0">

                <div class="task-cell cellName">
                  <div class="outside">                   
                    <mat-checkbox class="taskcheck" color="primary" (change)="isAllSelectedRow($event,item)"
                      (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)">
                    </mat-checkbox>
                  </div>

                  <button mat-icon-button (click)="markComplete(item)"
                    [ngClass]="{ markComplete: item.status==completedTaskStatusID }">
                    <mat-icon>check_circle_outline</mat-icon>
                  </button>

                  <div class="tname" (click)="getTaskDetail(item)">
                    <span *ngIf="taskListID==0 && taskListIDSharedWithMe==0" (click)="getTaskDetail(item)"
                      class="taskColor" [ngStyle]="{'background-color': item.color}"></span>
                    <span *ngIf="taskListID>0 || taskListIDSharedWithMe>0" (click)="getTaskDetail(item)"
                      class="taskColor" [ngStyle]="{'background-color': item.colourCode}"></span>

                    <span *ngIf="taskListID==0 && taskListIDSharedWithMe==0" (click)="getTaskDetail(item)"
                      class="taskTitle">{{ item.taskTitle }}</span>
                    <span *ngIf="taskListID>0 || taskListIDSharedWithMe>0" (click)="getTaskDetail(item)"
                      class="taskTitle">{{ item.taskTitle }}</span>
                   
                    <div class="taskstatusCount">
                     
                    </div>

                  </div>

                     <span *ngIf="!item.isInternal" class="externalTask" matTooltipClass="tooltip"
                      matTooltip="External task">
                      <mat-icon>arrow_outward</mat-icon>
                    </span>

                
                </div>                      
                           
                    <div class="task-cell cellDueDate">
                    <span *ngIf="item.isRequired==true" class="externalTask" matTooltipClass="tooltip" (click)="MakeTaskRequired(item,false)" matTooltip="Required">
                      <mat-icon style="color: red;">check</mat-icon>
                    </span>

                    <span *ngIf="item.isRequired==false" class="externalTask" matTooltipClass="tooltip" (click)="MakeTaskRequired(item,true)">
                      <mat-icon>check</mat-icon>
                    </span>
                  </div>

                     <div class="task-cell cellAssigne" (click)="getTaskDetail(item)">
                    <span> 

                      <div class="userpicinfo">                       
                     
                          <ul class="assignList">

                            <ng-container *ngFor="let item of getAssigne(item.taskAssignedEntity); let i = index; trackBy: trackByFn; " >
                               <li *ngIf="i <= 3">
                                <ng-container *ngIf="item.image; else showName">
                                  <div class="userImage" matTooltipClass="tooltip"   matTooltip="{{item.name}}">
                                    <img src="{{item.image}}" alt="{{item.name}}">
                                  </div>
                                </ng-container>
  
                                <ng-template #showName>
                                    <span class="shortName" matTooltipClass="tooltip" matTooltip="{{item.name}}">
                                      {{ getShortName(item.name) }}
                                    </span> 
                                </ng-template>
                              </li>
                              <li *ngIf="i > 3 && i == 4">
                                <span class="shortName">
                                  +{{4}}
                                </span> 
                              </li>
                            </ng-container>

                            <ng-container *ngIf="getAssigne(item.taskAssignedEntity).length == 0;">
                             <li> -  </li>
                           </ng-container>

                          </ul>

                       
                      </div>
                     

                    </span>
                  </div>


                <div class="task-cell cellDueDate" (click)="getTaskDetail(item)">
                  <p *ngIf="item.dueDate == null">
                    <mat-icon class="greyIcon">
                      event
                    </mat-icon>
                  </p>

                  <p *ngIf="item.dueDate != null">
                    {{ item.dueDate| date: "MM/dd/yyyy" }}
                  </p>
                </div>

                <div class="task-cell cellStatus">


                  <ng-select [readonly]="SingleTaskArchived==true" formControlName="status{{item.taskId}}" [searchable]="false" [clearAllText]="false"
                    (change)="onTaskListStatusChange($event,item)" class="status_dropdown">

                    <ng-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                      <span class="statusOptions" [style.background]="getBackground(stat.taskStatusID)">{{
                        stat.taskStatusName }}</span>
                    </ng-option>

                  </ng-select>

                </div>


                <div class="task-cell cellPriority">

                  <ng-select [readonly]="SingleTaskArchived==true" class="priority_dropdown" formControlName="priority{{item.taskId}}" [searchable]="false"
                    [clearAllText]="false" (change)="onTaskListPriorityChange($event,item)">

                    <ng-option *ngFor="let priority of taskPriorityNameColorCode" [value]="priority.val">
                      <span class="statusOptions"
                        [ngStyle]="{'color': priority.color}"><mat-icon>{{priority.icon}}</mat-icon>{{ priority.name
                        }}</span>
                    </ng-option>

                  </ng-select>


                </div>
               
                <div *ngIf="SingleTaskArchived==false" class="task-cell cellAction">

                  <span mat-icon-button [matMenuTriggerFor]="taskSubActions"><mat-icon>more_vert</mat-icon>
                  </span>
                  <mat-menu class="taskMatMenu" #taskSubActions="matMenu" xPosition="before">
                   
                    <button mat-menu-item (click)="openTaskUrl(item)">
                      <mat-icon>content_copy</mat-icon>Copy URL
                    </button>
                    <!-- <button mat-menu-item (click)="SaveAsTemplateForSingleTask(saveAsTemplateTaskDialog,item)">                      
                      <mat-icon>save</mat-icon>
                      Save as Template
                    </button> -->
                    <button mat-menu-item (click)="sendManualTaskReminder(item)">
                      <mat-icon> email</mat-icon>
                      Send Email Notification
                    </button>
                    <button mat-menu-item (click)="ArchiveTask(item)">
                      <mat-icon>archive</mat-icon>
                      Archive
                    </button>
                    <button mat-menu-item (click)="deleteTask(item)">
                      <mat-icon>delete</mat-icon>
                      Delete
                    </button>
                  </mat-menu>
                </div>
                           
               
            
              </div>

               <div *ngIf="ShowNoRecordFound==true" class="noRecordFound">No record found</div>

            </mat-card>
          </form>
         
        </mat-card>
        
        
      </div>
      
    </div>
  </div>
    </div>

   
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="basic" (click)="closeTask()">
      Cancel
    </button>    
  </mat-dialog-actions> 

<app-task-details
  *ngIf="showTaskDetail"
  [ngClass]="{ open: showTaskDetail }"
  (closeTaskDetail)="closeTaskDetail($event)"
  (closeSaveTaskDetail)="closeSaveTaskDetail($event)"
  (showPI)="showPIntelligence($event)"
  [taskId]="taskId"
  [mainModulename]="mainModuleName" [SingleTaskArchived]="SingleTaskArchived"
  [showAddGroupButtonCore]="showAddGroupButtonCore">
</app-task-details>